import { lazy } from "react";
import { RouteObject } from "react-router-dom";

const Suppliers = lazy(() => import("@/pages/admin/cms/suppliers/Suppliers/Suppliers"));
const AddSupplier = lazy(() => import("@/pages/admin/cms/suppliers/AddSupplier/AddSupplier"));
const EditSupplier = lazy(() => import("@/pages/admin/cms/suppliers/EditSupplier/EditSupplier"));

const Contents = lazy(() => import("@/pages/admin/cms/contents/Contents/Contents"));
const AllCategories = lazy(() => import("@/pages/admin/cms/contents/AllCategories/AllCategories"));
const CategoryOrganize = lazy(() => import("@/pages/admin/cms/contents/CategoryOrganize/CategoryOrganize"));
const AddContent = lazy(() => import("@/pages/admin/cms/contents/AddContent/AddContent"));
const EditContent = lazy(() => import("@/pages/admin/cms/contents/EditContent/EditContent"));

const Messages = lazy(() => import("@/pages/admin/cms/messages/Messages/Messages"));
const AddMessage = lazy(() => import("@/pages/admin/cms/messages/AddMessage/AddMessage"));
const EditMessage = lazy(() => import("@/pages/admin/cms/messages/EditMessage/EditMessage"));

const Events = lazy(() => import("@/pages/admin/cms/events/Events/Events"));
const AddEvent = lazy(() => import("@/pages/admin/cms/events/AddEvent/AddEvent"));
const EditEvent = lazy(() => import("@/pages/admin/cms/events/EditEvent/EditEvent"));

const Webinars = lazy(() => import("@/pages/admin/cms/webinars/Webinars/Webinars"));
const AddWebinar = lazy(() => import("@/pages/admin/cms/webinars/AddWebinar/AddWebinar"));
const EditWebinar = lazy(() => import("@/pages/admin/cms/webinars/EditWebinar/EditWebinar"));

const StopoverHotels = lazy(() => import("@/pages/admin/cms/stopover-hotels/StopoverHotels"));

const Sliders = lazy(() => import("@/pages/admin/cms/sliders/Sliders/Sliders"));

const Newsletter = lazy(() => import("@/pages/admin/cms/newsletter/Newsletter"));

const Error404 = lazy(() => import("@/pages/Error404"));

const cmsRoutes: RouteObject[] = [
  {
    index: true,
    element: <Error404 />,
  },
  {
    path: "contents",
    children: [
      {
        index: true,
        element: <Contents />,
      },
      {
        path: "new",
        element: <AddContent />,
      },
      {
        path: ":id",
        element: <EditContent />,
      },
      {
        path: "all-categories",
        element: <AllCategories />,
      },
      {
        path: ":type/organize",
        element: <CategoryOrganize />,
      },
    ],
  },
  {
    path: "suppliers",
    children: [
      {
        index: true,
        element: <Suppliers />,
      },
      {
        path: "new",
        element: <AddSupplier />,
      },
      {
        path: ":id",
        element: <EditSupplier />,
      },
    ],
  },
  {
    path: "messages",
    children: [
      {
        index: true,
        element: <Messages />,
      },
      {
        path: "new",
        element: <AddMessage />,
      },
      {
        path: ":id",
        element: <EditMessage />,
      },
    ],
  },
  {
    path: "events",
    children: [
      {
        index: true,
        element: <Events />,
      },
      {
        path: "new",
        element: <AddEvent />,
      },
      {
        path: ":id",
        element: <EditEvent />,
      },
    ],
  },
  {
    path: "webinars",
    children: [
      {
        index: true,
        element: <Webinars />,
      },
      {
        path: "new",
        element: <AddWebinar />,
      },
      {
        path: ":id",
        element: <EditWebinar />,
      },
    ],
  },
  {
    path: "sliders",
    element: <Sliders />,
  },
  {
    path: "newsletter",
    element: <Newsletter />,
  },
  {
    // Adding and editing happen on the page; ?new=1 opens the add dialog
    path: "stopover-hotels",
    element: <StopoverHotels />,
  },
];

export default cmsRoutes;
